<div
  class="filter-chips"
  [class.filter-chips--always-open]="alwaysOpen"
  [class.filter-chips--open]="isOpen"
  [class.filter-chips--can-expand]="canExpand"
>
  <div class="filter-chips__collapsable" (click)="toggleOpen()">
    <div class="filter-chips__inner" #container>
      <div class="filter-chips__row">
        <ul class="filter-chips__list" #list>
          <li class="filter-chips__item">
            <div class="filter-chip">
              <span class="filter-chip__text">
                {{ contractType.text | i18n }}
              </span>
            </div>
          </li>

          <ng-container *ngIf="shouldDisplayRegions">
            <li class="filter-chips__item" *ngFor="let region of regions">
              <div class="filter-chip">
                <span class="filter-chip__text">
                  {{ region.name }}
                  <ng-container *ngIf="shouldDisplayRadius">
                    ({{ radius.text }})
                  </ng-container>
                </span>
              </div>
            </li>
          </ng-container>

          <ng-container *ngIf="shouldDisplayMainCategory">
            <li class="filter-chips__item">
              <div class="filter-chip">
                <span class="filter-chip__text">
                  {{ mainCategory.text | i18n }}
                </span>
              </div>
            </li>
          </ng-container>

          <ng-container *ngIf="shouldDisplaySubcategories">
            <li
              class="filter-chips__item"
              *ngFor="let subcategory of subcategories"
            >
              <div class="filter-chip">
                <span class="filter-chip__text">
                  {{ subcategory.text | i18n }}
                </span>
              </div>
            </li>
          </ng-container>

          <ng-container *ngIf="shouldDisplayPrice">
            <li class="filter-chips__item">
              <div class="filter-chip">
                <span class="filter-chip__text">
                  {{ 'common.currency.short' | i18n }} {{ price }}
                </span>
              </div>
            </li>
          </ng-container>

          <ng-container *ngIf="shouldDisplayRoomCount">
            <li class="filter-chips__item">
              <div class="filter-chip">
                <span class="filter-chip__text">
                  {{ roomCount }} {{ 'filters.roomCount.label' | i18n }}
                </span>
              </div>
            </li>
          </ng-container>

          <ng-container *ngIf="shouldDisplayLivingSpace">
            <li class="filter-chips__item">
              <div class="filter-chip">
                <span class="filter-chip__text">
                  {{ livingSpace }} m<sup>2</sup>
                  {{ 'filters.livingSpace.label' | i18n }}
                </span>
              </div>
            </li>
          </ng-container>

          <ng-container *ngIf="shouldDisplayPropertySpace">
            <li class="filter-chips__item">
              <div class="filter-chip">
                <span class="filter-chip__text">
                  {{ propertySpace }} m<sup>2</sup>
                  {{ 'filters.propertySpace.label' | i18n }}
                </span>
              </div>
            </li>
          </ng-container>

          <ng-container *ngIf="shouldDisplayUsageSpace">
            <li class="filter-chips__item">
              <div class="filter-chip">
                <span class="filter-chip__text">
                  {{ usageSpace }} m<sup>2</sup>
                  {{ 'filters.usageSpace.label' | i18n }}
                </span>
              </div>
            </li>
          </ng-container>
        </ul>

        <div
          class="filter-chips__more-indicator"
          *ngIf="moreCount && !isOpen && canExpand"
        >
          +{{ moreCount }}
        </div>

        <div class="filter-chips__arrow-wrapper">
          <button class="filter-chips__arrow-button">
            <i class="filter-chips__arrow-icon material-icon">
              keyboard_arrow_down
            </i>
          </button>
        </div>
      </div>

      <div class="filter-chips__row">
        <div class="filter-chips__edit-text" *ngIf="!alwaysOpen">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  </div>
</div>
